import React, { useLayoutEffect, useState, useEffect, useRef, Fragment, useCallback } from 'react'
import { SelectBox, Button, TextBox, CheckBox, TextArea, DateBox, FileUploader } from "devextreme-react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { ProjectService } from '../../../apis/apiServices/Project'
import { VendorService } from '../../../apis/apiServices/Vendor'
import { CategoryService } from '../../../apis/apiServices/Category'
import { GetWorkFlowForApprovalForIom } from '../../../apis/apiServices/WorkFlow';
import Modal from "react-modal";
import Swal from 'sweetalert2';
import { Icon } from "@iconify/react";
import { Loader } from '../../Shared/PageLoader';
import DataGrid, {
    Column,
    Export,
    Editing,
    Pager,
    Paging,
    SearchPanel,
    LoadPanel, Scrolling, Selection
} from "devextreme-react/data-grid";
import { FundRequestService } from '../../../apis/apiServices/FundRequest';
import Popup from "devextreme-react/popup";
import { getReduxCompany } from '../../../helper/sessionHelper';

export default function AddEditFundRequestComponent(props) {
    const location = useLocation();
    const { fundRequestId, isMytask } = location.state || {};
    const user = useSelector((state) => state.user.data);
    const navigate = useNavigate();
    useLayoutEffect(() => {
        const titleElement = document.querySelector("#pageTitle");
        if (titleElement) {
            if (!fundRequestId) {
                titleElement.innerHTML = "New FR - Fund Request";
            } else {
                titleElement.innerHTML = "Update FR - Fund Request"
                getFundRequestDataForUpdate(fundRequestId);
            }
        }

        if (fundRequestId) {
            getAttachmentsByRequestIdAndRequestTypeId(fundRequestId, 1);
        }
        getProjectDropdownData();
        getCategoryDropdown();
    }, []);
    const [projectDropdownData, setProjectDropdownData] = useState(null);
    const [selectedVendorId, setSelectedVendorId] = useState(null);
    const [vendorDropdownData, setVendorDropdownData] = useState(null);
    const [vendorBankDetailList, setVendorBankDetailList] = useState(null);
    //const [vendorDataList, SetVendorDataList] = useState(null);
    const [formCategoryDropdownData, setFormCategoryDropdownData] = useState([]);
    const [addVendorModalOpen, setAddVendorModalOpen] = useState(false);
    const [iomApproversByWorkflow, setIOMApproversByWorkflow] = useState([]);
    const [workflowData, setWorkflowData] = useState([]);
    const [iomApprovers, setIOMApprovers] = useState([]);
    const [fundRequestData, setFundRequestData] = useState(null);
    const [files, setFiles] = useState([]);
    const [removedAttachmentIds, setRemovedAttachmentIds] = useState([]);
    const [fundRequest, setFundRequest] = useState({
        projectId: 0,
        categoryId: 0,
        departmentId: 0,
        requestDate: "",
        subject: "",
    });
    const [vendorData, setVendorData] = useState({
        vendorBankData: [],
        vendorId: 0,
        balanceAmount: 0,
        recommendedAmount: 0,
        vendorName: "",
        note: ""
    });
    const [errors, setErrors] = useState({});
    const [error, setError] = useState({});
    const [loading, setLoading] = useState(false)
    const [vendorDetailList, setVendorDetailList] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isSaveModalVisible, setIsSaveModalVisible] = useState(false);
    const [charCount, setCharCount] = useState(0);
    const [remarks, setRemarks] = useState(null);
    const [remarksPopup, setRemarksPopup] = useState({
        remarkType: "itemApproval", // itemApproval, deleteItem, approveFr, backToDraftFr
        title: "Approval",
        isModalVisible: false,
        itemId: 0,
        remarks: "",
    });

    const [isValidRecomAmt, setIsValidRecomAmt] = useState(false);
    const [isValidAdvance, setIsValidAdvance] = useState(false);
    const [advRequestPaymentId, setAdvRequestPaymentId] = useState(null);

    const getFundRequestDataForUpdate = async () => {
        try {
            let body = { 'fundRequestId': fundRequestId, 'userId': user?.userId }
            const response = await FundRequestService.getFundRequestDetailsByFRId(body)
            setFundRequest(response?.data);
            setVendorDetailList(response?.data?.items?.map((item) => {
                return {
                    ...item,
                    vendorBankName: item?.bankName,
                    advRequestPaymentId: item?.advPaymentRequestId,
                    isValidAdvance: item?.isAdvancePayment,
                }
            }));
            //GetWorkFlowForApprovers(response?.data?.categoryId, response?.data?.projectId, response?.data?.departmentId);
            //setFRDataForEdit();
        } catch (error) {
            console.log("Error getFundRequestDataForUpdate===>", error);
        }
    }

    const getProjectDropdownData = async () => {
        try {
            const response = await ProjectService.getProjectByUserId(user?.userId)
            setProjectDropdownData(response?.data);
        } catch (error) {
            console.log("Error getProjectDropdownData===>", error);
        }
    }

    const getCategoryDropdown = async (projectId, departmentId) => {
        try {
            let body = { formId: props?.featurePermission?.featureId, projectId: projectId, departmentId: departmentId }
            const response = await CategoryService.getWorkflowCategoryDropdown(body)
            setFormCategoryDropdownData(response?.data);
        } catch (error) {
            console.log("Error getCategoryDropdown===>", error);
        }
    }

    const GetWorkFlowForApprovers = async (formCategoryId, projectId, departmentId) => {
        try {
            // user?.userDepartmentId
            let body = { formId: props?.featurePermission?.featureId, formTypeId: formCategoryId || 0, projectId: projectId || 0, departmentId: departmentId || 0 }
            const response = await GetWorkFlowForApprovalForIom(body)
            setWorkflowData(response);
            const stagesWithApprovers = response?.stages
                ?.filter(stage => stage?.approvers && stage?.approvers?.length > 0)
                ?.map(stage => ({
                    actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
                    approvers: stage?.approvers
                }));
            const Approvers = response?.stages
                ?.filter(stage => stage?.approvers && stage?.approvers?.length > 0)
                ?.flatMap(stage =>
                    stage?.approvers?.map(approver => ({
                        actionTypeId: stage?.actionTypeId,
                        userId: approver?.userId,
                        canEdit: approver?.canEdit,
                        stageId: stage?.index,
                    }))
                );
            setIOMApprovers(Approvers);
            setIOMApproversByWorkflow(stagesWithApprovers);
            // console.log(Approvers);
        } catch (error) {
            console.log("Error getDepartmentDropdown===>", error);
        }
    }

    const handleFormData = (key, value) => {
        setFundRequest((prevState) => {
            return {
                ...prevState,
                [key]: value
            }
        });
    }

    const validateForm = () => {
        let isValid = true;
        let err = {};

        if (!fundRequest?.subject) {
            err.subject = "Please enter subject";
            isValid = false;
        }
        else { err.subject = ""; }
        if (!fundRequest?.projectId) {
            err.projectId = "Please select project";
            isValid = false;
        }
        else { err.projectId = ""; }

        if (!fundRequest?.categoryId) {
            err.categoryId = "Please select category";
            isValid = false;
        }
        else { err.categoryId = ""; }

        if (isValidRecomAmt) {

            isValid = false;
            // Swal.fire("Warning", "Recommended amount cannot be greater than Ledger amount", "Warning")
        }



        //console.log('err', err)
        setErrors(err);
        return isValid;
    }

    const addNewFundRequest = async (frStatus) => {

        if (frStatus === 5) {
            const hasOverpaidItem = vendorDetailList.some(
                item =>
                    !item.isAdvancePayment && // only check when not advance payment
                    Number(item.balanceAmt) !== 0 &&
                    Number(item.recommendedAmt) > Number(item.balanceAmt)
            );


            if (hasOverpaidItem) {
                Swal.fire(
                    "Amount Limit Warning!",
                    "Recommended amount is greater than ledger balance. Please remove this vendor and re-add them using the Advance Request option.",
                    "warning"
                );
                return;
            }

        }

        if (!validateForm()) return false;
        try {
            let body = {
                fundRequestId: fundRequestId || 0,
                projectId: fundRequest?.projectId || 0,
                departmentId: user?.userDepartmentId || 0,
                categoryId: fundRequest?.categoryId || 0,
                subject: fundRequest?.subject || "",
                serialNo: fundRequest?.serialNo || "",         // if you generate serial no somewhere
                workflowId: workflowData?.id ?? 0,
                totalBalanceAmt: vendorDetailList?.reduce((sum, v) => sum + (Number(v.balanceAmt) || 0), 0),
                totalRecommendAmt: vendorDetailList?.reduce((sum, v) => sum + (Number(v.recommendedAmt) || 0), 0),
                totalPaidAmt: vendorDetailList?.reduce((sum, v) => sum + (Number(v.paidAmt) || 0), 0),
                requestStatusId: frStatus || 0,
                isUpdate: frStatus === 5 ? true : false,
                remarks: remarks || "",
                companyId : getReduxCompany()?.companyId || 0,
                modifiedBy: iomApprovers?.[0]?.actionTypeId === 8 ? iomApprovers?.[0]?.userId : user?.userId,
                modifiedFeatureId: fundRequest?.modifiedFeatureId || 0,
                items: vendorDetailList || [],
                RemovedAttachmentIds: fundRequestId && (removedAttachmentIds ?? [])
            }

            if (body.items.length === 0) {
                Swal.fire("Warning", "Please Add vendor", "warning")
                return false;
            }
            var requestFormData = new FormData();
            requestFormData.append("FundRequestJson", JSON.stringify(body));

            files.forEach((file) => {
                requestFormData.append("Documents", file);
            });

            //fundRequestId && requestFormData.append("RemovedAttachmentIds", JSON.stringify(removedAttachmentIds ?? []))


            setLoading(true)
            const response = fundRequestId ? await FundRequestService.updateFundRequest(requestFormData) : await FundRequestService.addFundRequest(requestFormData)
            setLoading(false)
            if (response?.isSuccess) {

                Swal.fire("", response?.message, "success")
                    .then(() => {
                        navigate(-1);
                    });
            } else {
                Swal.fire("Error", response?.message, "error")
            }
        }
        catch (error) {
            console.log("Error addNewFundRequest===>", error);
        }
    }

    const validateSendrequest = () => {
        if (!validateForm()) return false;
        console.log("vendorDetailList from validateSendrequest===>", vendorDetailList)
        if (vendorDetailList?.length === 0 || !vendorDetailList) {
            Swal.fire("Warning", "Please Add vendor", "warning")
            return false;
        }
        setIsModalVisible(true);

    }

    const openModal = () => {
        setAddVendorModalOpen(true);
        getVendorDropdownData()
    };

    const getAttachmentsByRequestIdAndRequestTypeId = async (requestId, requestTypeId) => {
        try {
            const response = await FundRequestService.getRequestAttachmentsByRequestId(requestId, requestTypeId);
            let arr = []
            response?.data?.map((item, key) => {
                let obj = {
                    attachmentId: item?.attachmentId,
                    filePath: item?.filePath,
                    name: item?.fileName,
                    size: item?.fileSize,
                    type: item?.fileType
                }
                arr.push(obj)
            })
            setFiles(arr);

        } catch (error) {
            console.log("Error getAttachmentsByRequestIdAndRequestTypeId===>", error);
        }
    }

    const validateVendorDetailsForm = () => {
        let isValid = true;
        let err = {};

        if (!vendorData?.vendorId) {
            err.vendorId = "Please select vendor";
            isValid = false;
        }
        else { err.vendorId = ""; }
        // if (!vendorData?.balanceAmount || vendorData?.balanceAmount <= 0) {
        //     err.balanceAmount = "Please enter balance amount";
        //     isValid = false;
        // }
        // else { err.balanceAmount = ""; }

        if (!vendorData?.recommendedAmount || vendorData?.recommendedAmount <= 0) {
            err.recommendedAmount = "Please enter recommended amount";
            isValid = false;
        }
        else { err.recommendedAmount = ""; }

        if (
            // vendorData?.balanceAmount > 0 &&
            vendorData?.recommendedAmount > vendorData?.balanceAmount &&
            (!vendorData?.isValidAdvance)
        ) {
            err.recommendedAmount = "Recommended amount is greater than ledger balance, please check advance option";
            isValid = false;
        }

        if (!vendorData?.note) {
            err.note = "Please enter note";
            isValid = false;
        }
        else { err.note = ""; }


        if (!vendorData?.vendorBankData?.vendorBankId) {
            err.vendorBankId = "Please select bank";
            isValid = false;
        }
        else { err.vendorBankId = ""; }

        if (vendorData?.isValidAdvance && !vendorData?.advRequestPaymentId) {
            err.advRequestPaymentId = "Please enter advance request id";
            isValid = false;
        }
        else { err.advRequestPaymentId = ""; }

        //console.log('err', err)
        setErrors(err);
        return isValid;
    }

    const addVendorDetails = async () => {
        if (!validateVendorDetailsForm()) return false;
        try {
            // Prepare new object in your required format
            const newVendorDetail = {
                vendorId: vendorData?.vendorId || 0,
                vendorBankId: vendorData?.vendorBankData?.vendorBankId || 0,
                vendorBankName: vendorData?.vendorBankData?.bankName || "",
                vendorName: vendorData?.vendorBankData?.vendorName || "",
                vendorAccountNo: vendorData?.vendorBankData?.accountNo || 0,
                itemSerialNo: "", // you can assign serial number logic here
                balanceAmt: vendorData?.balanceAmount || 0,
                recommendedAmt: vendorData?.recommendedAmount || 0,
                paidAmt: 0, // default 0 if not provided
                paymentDate: "", // you can set current date if required
                note: vendorData?.note || "",
                isAdvancePayment: vendorData?.isValidAdvance || false,
                advPaymentRequestId: vendorData?.advRequestPaymentId || ""
            };

            // Update state
            setVendorDetailList((prev) => (prev ? [...prev, newVendorDetail] : [newVendorDetail]));

            // Close modal + reset
            setAddVendorModalOpen(false);
            setErrors({});
            setVendorData({});
        }
        catch (error) {
            console.log("Error addNewFundRequest===>", error);
        }
    }

    const getVendorDropdownData = async () => {
        try {
            const response = await VendorService.GetVendorDropdown()
            setVendorDropdownData(response?.data);
        } catch (error) {
            console.log("Error getVendorDropdownData===>", error);
        }
    }

    const getVendorBankDetailsByVendorId = async (vendorId) => {
        try {
            const response = await VendorService.getVendorBankDetailsByVendorId(vendorId)
            setVendorBankDetailList(response?.data);
        } catch (error) {
            console.log("Error getVendorBankDetailsByVendorId===>", error);
        }
    }

    const handleValueChange = (field, value) => {
        setVendorData((prev) => {
            const updated = { ...prev, [field]: value };
            validate(updated, field);
            return updated;
        });
        // 👇 If this is the bank radio field, update selection too
        if (field === "vendorBankData") {
            setSelectedVendorId(value.vendorBankId);
        }
    };

    // Validation function
    const validate = (data, field) => {
        setErrors((prevErrors) => {
            let newErrors = { ...prevErrors };
            debugger;

            if (field === "recommendedAmount" || field === "balanceAmount") {
                if (data.balanceAmount > 0 && data.recommendedAmount > data.balanceAmount) {
                    newErrors.recommendedAmount = "Recommended amount is greater than ledger balance, please check advance option";
                } else {
                    delete newErrors.recommendedAmount;
                }
            }
            if ((!data?.advRequestPaymentId) && data.isValidAdvance) {

                newErrors.advRequestPaymentId = "Please enter advance request id"
            }
        });
    };

    const handleAproveRemarksChange = (e) => {
        const value = e?.event?.target?.value?.slice(0, 300) || ""; // Auto-trim to 300 chars

        setRemarks(value);
        setCharCount(value.length);

        // Set error only if max limit was hit
        setError((prev) => ({
            ...prev,
            remarks: value.length >= 300
                ? "Remarks cannot exceed 300 characters"
                : "",
        }));
    };

    const handleApproveSubmit = async () => {
        const newError = {};

        if (!remarks?.trim()) {
            newError.remarks = "Please enter remarks";
        } else if (remarks?.length > 300) {
            newError.remarks = "Remarks cannot exceed 300 characters";
        } else {
            setError({ remarks: "", userIdForRejectIOM: "" });
        }

        if (Object.keys(newError).length > 0) {
            setError(newError);
            return;
        }

        setLoading(true)

        let frStatus = 3
        await addNewFundRequest(frStatus)

        setLoading(false)
        setIsModalVisible(false);
        setRemarks("");
        setError({});
    };

    const getButtonText = () => {
        const buttontext = fundRequestId ? fundRequest?.actionDetails : iomApprovers
        if (!Array.isArray(buttontext) || buttontext?.length === 0) return "Send";

        const actionTypeId = fundRequestId ? buttontext[1]?.statusId : buttontext[0]?.actionTypeId;

        if (actionTypeId === 2) return "Send for Recommendation";
        if (actionTypeId === 7) return "Send for Verification";

        return "Send";
    };

    const deleteFundRequestItem = async (rowData) => {
        try {
            const result = await Swal.fire({
                icon: 'warning',
                title: 'Are you sure?',
                text: 'You want to delete this item?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
            });

            if (!result.isConfirmed) return;


            let { itemId, itemSerialNo, fundRequestId } = rowData;

            let body = {
                itemId: itemId,
                itemSerialNo: itemSerialNo,
                remark: "",
                fundRequestId: fundRequestId,
                modifiedBy: user?.userId,
            }

            if (rowData?.itemId) {
                var response = await FundRequestService.deleteFundRequestItemByItemId(body)
                if (response?.isSuccess) {
                    Swal.fire({ icon: 'success', title: 'Success', text: response?.message, })
                        .then(() => {
                            setVendorBankDetailList(null);
                            setSelectedVendorId(null);
                        });
                } else {
                    Swal.fire({ icon: 'error', title: 'Error', text: response?.message, })
                }
            }
            setSelectedVendorId(null);
            setVendorDetailList((prev) =>
                // prev.filter(
                //     (item) => item?.vendorId !== rowData?.vendorId
                // )
                prev.filter(
                    (item) => ((item?.vendorId !== rowData?.vendorId) || (item?.vendorBankId !== rowData?.vendorBankId))
                )
            );

        } catch (error) {
            console.log("Error approveOrRejectFundRequest===>", error);
        }
    }

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e?.target?.files); // Convert FileList to Array
        setFiles(prevState => [...prevState, ...selectedFiles]);
    };

    const handleFileRemove = (index) => {
        let attachmentToRemove = files?.find((_, i) => i === index)

        setFiles((prev) => prev?.filter((_, i) => i !== index));

        if (attachmentToRemove?.attachmentId) {
            setRemovedAttachmentIds(prevState => {
                let previousIds = prevState || [];
                return [
                    ...previousIds,
                    attachmentToRemove?.attachmentId || 0
                ]
            });
        }
    };

    useEffect(() => {
        if (fundRequestId) {
            //GetWorkFlowForApprovers(fundRequest?.categoryId, fundRequest?.projectId, fundRequest?.departmentId);
            const stagesWithApprovers = fundRequest?.actionDetails
                ?.filter(stage => stage?.approvers && stage?.approvers?.length > 0)
                ?.filter(stage => stage?.stageIndex !== 1).map(stage => ({
                    actionTypeName: stage?.status?.trim() + ' ' + "By", // optional: remove extra spaces or \r\n
                    approvers: stage?.approvers.map(approver => ({
                        ...approver,
                        actionTypeId: stage?.actionTypeId,
                        designationName: approver?.designation,
                        userName: approver?.firstName + " " + approver?.lastName,
                    }))
                }));
            setIOMApproversByWorkflow(stagesWithApprovers);
        }
        else {
            GetWorkFlowForApprovers(fundRequest?.categoryId, fundRequest?.projectId, user?.userDepartmentId);
        }
    }, [fundRequest?.categoryId, fundRequestId]);

    useEffect(() => {
        getCategoryDropdown(fundRequest.projectId, fundRequest?.fundRequestId ? fundRequest?.departmentId : user?.userDepartmentId)
    }, [fundRequest?.projectId])


    return (
        <Fragment>
            <div className="content">
                <div className="card card-primary">
                    <div className="card-header">
                        <div className='row align-items-center'>
                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                <h3 className="card-title text-primary">
                                    {fundRequest?.fundRequestId &&
                                        <span>
                                            <span style={{ backgroundColor: '#282c7d', color: '#ffffff', borderRadius: '0.3rem', padding: '0.2rem 0.5rem' }}>Request No. {fundRequest?.serialNo}</span>&nbsp;
                                        </span>}
                                    From - {user?.userDepartmentName} Department</h3>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 text-right'>
                                <Button
                                    text="Cancel"
                                    icon="close"
                                    onClick={() => {
                                        navigate(-1);
                                    }}
                                    stylingMode="outlined"
                                    type="default"
                                    className='mr-2'
                                    hint='Cancel'
                                />
                                {isMytask &&
                                    <Button
                                        text="Save"
                                        icon="check"
                                        onClick={() => {
                                            if (vendorDetailList.length === 0) {
                                                Swal.fire("Warning", "Please Add vendor", "warning")
                                                return false;
                                            }
                                            // ✅ Validate if any item has paidAmt = 0
                                            const hasZeroPaidAmt = (vendorDetailList || []).some(
                                                (item) => Number(item.recommendedAmt) === 0
                                            );

                                            if (hasZeroPaidAmt) {
                                                Swal.fire(
                                                    "Amount Limit Warning!",
                                                    "Recommended amount cannot be 0 for any vendor.",
                                                    "warning"
                                                );
                                                return;
                                            }

                                            // 🔹 Validation: Check if any paidAmt > recommendedAmt
                                            // const hasOverpaidItem = vendorDetailList.some(
                                            //     item => Number(item.recommendedAmt) > Number(item.balanceAmt)
                                            // );
                                            debugger
                                            const hasOverpaidItem = vendorDetailList.some(
                                                item =>
                                                    !item.isAdvancePayment && // only check when not advance payment
                                                    Number(item.balanceAmt) !== 0 &&
                                                    Number(item.recommendedAmt) > Number(item.balanceAmt)
                                            );


                                            if (hasOverpaidItem) {
                                                Swal.fire(
                                                    "Amount Limit Warning!",
                                                    "Recommended amount is greater than ledger balance. Please remove this vendor and re-add them using the Advance Request option.",
                                                    "warning"
                                                );
                                                return;
                                            }
                                            setIsSaveModalVisible(true);  // Show popup first
                                        }}
                                        stylingMode="contained"
                                        type="default"
                                        hint='Save'
                                    />
                                }
                                {!isMytask &&
                                    <>
                                        <Button
                                            text="Save as Draft"
                                            icon="save"
                                            onClick={(e) => {
                                                //let iomStatus = 8
                                                let frStatus = 8
                                                addNewFundRequest(frStatus);
                                            }}
                                            stylingMode="contained"
                                            type="default"
                                            hint='Save as Draft'
                                        />
                                        &nbsp;&nbsp;
                                        <Button
                                            text={getButtonText()}
                                            icon="check"
                                            onClick={(e) => {
                                                // let frStatus = 3
                                                // addNewFundRequest(frStatus)
                                                //setIsModalVisible(true);
                                                validateSendrequest();

                                            }}
                                            stylingMode="contained"
                                            type="default"
                                            hint='Send for approval'
                                        />
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <div className="form-group">
                                    <label>
                                        Project <span className="text-danger">*</span>
                                    </label>
                                    <SelectBox
                                        dataSource={projectDropdownData}
                                        valueExpr="id"
                                        displayExpr="name"
                                        className="form-control"
                                        placeholder="Select project"
                                        searchEnabled
                                        showClearButton={true}
                                        value={fundRequest?.projectId}
                                        readOnly={(!fundRequestId) ? false : true}
                                        onValueChanged={(e) => {
                                            handleFormData("projectId", e?.value);
                                            getCategoryDropdown(e?.value, user?.userDepartmentId)
                                            //GetWorkFlowForApprovers(fundRequest?.categoryId, e?.value, fundRequest?.departmentId);
                                        }}
                                    />
                                    {errors?.projectId && <span className="error invalid-feedback">{errors?.projectId}</span>}
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <div className="form-group">
                                    <label>
                                        Category <span className="text-danger">*</span>
                                    </label>
                                    <SelectBox
                                        dataSource={formCategoryDropdownData || []}
                                        valueExpr="id"
                                        displayExpr="name"
                                        className="form-control"
                                        placeholder="Select"
                                        searchEnabled
                                        showClearButton={true}
                                        value={fundRequest?.categoryId}
                                        //disabled={!fundRequest?.projectId}
                                        readOnly={(!fundRequestId) ? false : true}
                                        onValueChanged={(e) => {
                                            handleFormData("categoryId", e?.value);
                                            //GetWorkFlowForApprovers(e?.value, fundRequest?.projectId, user?.userDepartmentId);
                                        }}
                                    />
                                    {errors?.categoryId && <span className="error invalid-feedback">{errors?.categoryId}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-8 col-md-8 col-sm-12">
                                <div className="form-group">
                                    <label>
                                        Subject <span className="text-danger">*</span>
                                    </label>
                                    <TextBox
                                        value={fundRequest?.subject}
                                        onValueChanged={(e) => handleFormData("subject", e.value)}
                                        placeholder="Enter subject"
                                    // readOnly={
                                    //     !iomData
                                    //         ? false
                                    //         : ((iomData?.iomStatusId === 8 || iomData?.iomStatusId === 4)
                                    //             && iomData?.createdByUserId === user?.userId)
                                    //             ? false
                                    //             : true
                                    // }
                                    />
                                    {errors?.subject && <span className="error invalid-feedback">{errors?.subject}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "8px" }}>
                            <div className="col-lg-8 col-md-8 col-sm-12">
                                <Button
                                    text="Add Vendor"
                                    icon="plus"
                                    onClick={() => openModal()}
                                    stylingMode="outlined"
                                    type="default"
                                    className='mr-2'
                                    hint='add vendor'
                                />
                                {errors?.vendorId && <span className="error invalid-feedback">{errors?.vendorId}</span>}
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "15px" }}>
                            {/* DevExtreme DataGrid */}
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <DataGrid
                                    dataSource={vendorDetailList || []}
                                    className='iom-grid'
                                    showBorders={true}
                                    // rowAlternationEnabled={true}
                                    showRowLines={true}
                                    columnAutoWidth={false}
                                    showColumnLines={false}
                                    allowFiltering
                                    columnHidingEnabled
                                    //wordWrapEnabled={true}
                                    onCellValueChanged={(e) => {
                                        if (e.column.dataField === "recommendedAmt") {
                                            // update your state when payment amount changes
                                            const updatedItems = vendorDetailList?.map(item =>
                                                item.itemId === e.key ? { ...item, recommendedAmt: e.value } : item
                                            );
                                            setVendorDetailList(prev => ({ ...prev, items: updatedItems }));
                                        }
                                    }}
                                >
                                    <Scrolling mode="standard" />
                                    <Paging enabled={false} />
                                    {/* enable editing */}
                                    <Editing mode="cell" allowUpdating={true} />
                                    <Column
                                        width="50px"
                                        cellRender={(cellData) => {
                                            const rowData = cellData?.data;

                                            return (
                                                <>
                                                    {/* Delete */}
                                                    <span title="Delete">
                                                        <Icon
                                                            title="Delete"
                                                            className='iconify-size'
                                                            icon="fluent:delete-32-regular"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                deleteFundRequestItem(rowData);
                                                            }}
                                                        />
                                                    </span>
                                                </>
                                            );
                                        }}
                                    />
                                    <Column dataField="vendorName" caption="Vendor" allowEditing={false} width="300px" />
                                    <Column dataField="vendorBankName" caption="Bank" allowEditing={false} width="150px"
                                        cellRender={(e) => (
                                            <div>
                                                <div>{e.data?.vendorBankName}</div>
                                                <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data?.vendorAccountNo}</div>
                                            </div>
                                        )} />
                                    <Column dataField="balanceAmt" caption="Ledger Balance" allowEditing={false} width="200px" />
                                    {/* <Column dataField="recommendedAmt" caption="Recommended Amt." dataType="number" width="200px"
                                        format="#,##0.##"
                                        allowEditing={true}
                                        editorOptions={{
                                            min: 0,
                                            placeholder: "Enter amount",
                                        }}
                                        cellRender={({ data }) => {
                                            return (
                                                (data.recommendedAmt === 0 || data.recommendedAmt === null || data.recommendedAmt === undefined ? (
                                                    <span style={{ color: 'silver' }}>Enter amount</span>
                                                ) : (
                                                    <span style={{ color: '#333' }}>
                                                        Rs. {data.recommendedAmt.toLocaleString('en-IN')}
                                                    </span>
                                                ))
                                            );
                                        }}
                                    /> */}
                                    <Column
                                        dataField="recommendedAmt"
                                        caption="Recommended Amt."
                                        dataType="number"
                                        width="250px"
                                        allowEditing={true}
                                        cellRender={({ data }) => {
                                            console.log(data)
                                            const value = data.recommendedAmt || 0;
                                            const balance = data.balanceAmt || 0;
                                            const isInvalid = value > balance && (!data?.isAdvancePayment); // (balance > 0) && 
                                            setIsValidRecomAmt(isInvalid);

                                            const displayValue =
                                                value === 0 || value === null || value === undefined
                                                    ? ""
                                                    : `Rs. ${value.toLocaleString("en-IN")}`;

                                            return (
                                                <div>
                                                    <div>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter amount"
                                                            value={displayValue}
                                                            onChange={(e) => {
                                                                // remove formatting to get numeric value
                                                                const cleanValue = e.target.value.replace(/[^\d]/g, "");
                                                                const newValue = parseFloat(cleanValue || 0);

                                                                // update grid data
                                                                if (!isNaN(newValue)) {
                                                                    data.recommendedAmt = newValue;
                                                                }
                                                            }}
                                                            style={{
                                                                width: "100%",
                                                                border: isInvalid ? "1px solid red" : "1px solid #cccef1",
                                                                borderRadius: "4px",
                                                                padding: "4px 6px",
                                                                textAlign: "right",
                                                                color: value ? "#333" : "silver",
                                                                fontWeight: "normal",
                                                                outline: "none",
                                                            }}
                                                        />
                                                    </div>
                                                    {isInvalid && (
                                                        <div
                                                            style={{
                                                                color: "red",
                                                                fontSize: "11px",
                                                                marginTop: "2px",
                                                                textAlign: "right",
                                                                whiteSpace: "normal",       // allow wrapping
                                                                wordBreak: "break-word",    // break long text
                                                                background: "#fff6f6",      // light red background for readability
                                                                borderRadius: "4px",
                                                                padding: "2px 4px",
                                                                display: "block",
                                                                lineHeight: "1.2",
                                                            }}
                                                        >
                                                            Recommended amount is greater than ledger balance. Please remove this vendor and re-add them using the Advance Request option.
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        }}
                                    />



                                    <Column dataField="advPaymentRequestId" caption="Advance Request Id" allowEditing={false} width={150} />
                                    <Column dataField="note" caption="Note" allowEditing={false} />
                                </DataGrid>
                            </div>
                        </div>
                        {/* Attachment */}
                        <div className='mb-1' style={{ marginTop: "15px" }}>
                            <div className="form-group">{/* <span onClick={() => { console.log(files) }}>console</span> */}
                                <label htmlFor="fileUpload" className='btn btn-outline-primary mb-1' style={{ cursor: 'pointer' }} title='Attachment'> <i class="fas fa-plus"></i> Attachment </label>
                                <input
                                    id="fileUpload"
                                    type="file"
                                    style={{ display: "none" }}
                                    onChange={handleFileChange}
                                />
                            </div>
                            <div className='attachment-container'>
                                {files?.map((file, idx) => (
                                    <div
                                        key={idx}
                                        className='attachment-item'
                                    >
                                        <div class="d-flex justify-content-between align-items-center" style={{ cursor: 'pointer' }}>
                                            <div className='attachment-name'
                                                onClick={() => {
                                                    if (file?.filePath) {
                                                        const fileUrl =
                                                            process.env.REACT_APP_CDN_VISHWAM_BASE_URL +
                                                            file?.filePath;
                                                        window.open(fileUrl, '_blank');
                                                    }
                                                }}>
                                                {file?.name}
                                            </div>
                                            <button
                                                className='btn pt-0 pb-0 pr-0'
                                                onClick={() => handleFileRemove(idx)}
                                            >
                                                <i class="fas fa-times"></i>
                                            </button>
                                        </div>
                                        <div className='small'>
                                            {(file?.size / 1024).toFixed(0)}kb
                                        </div>

                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "12px" }}>
                            {iomApprovers?.[0]?.actionTypeId === 8 ? "" :
                                <>
                                    <div className="col-lg-4 col-md-12 col-sm-4">
                                        <div className="form-group">
                                            {iomApprovers?.[0]?.actionTypeId === 8 ? ("") : (<label>Prepared By</label>)}
                                            {fundRequest?.fundRequestId ? (
                                                <TextBox
                                                    className="form-control"
                                                    placeholder="Enter name"
                                                    showClearButton={false}
                                                    //value={user?.firstName + " " + user?.lastName + " (" + user?.userDesignationName + ")"}
                                                    value={fundRequest?.createdBy}
                                                    readOnly={true}
                                                //onValueChanged={(e) => handleUserChange(e, "employeeId")}
                                                />)
                                                :
                                                iomApprovers?.[0]?.actionTypeId === 8 ? (
                                                    "")
                                                    :
                                                    (<TextBox
                                                        className="form-control"
                                                        placeholder="Enter name"
                                                        showClearButton={false}
                                                        value={user?.firstName + " " + user?.lastName + " (" + user?.userDesignationName + ")"}
                                                        //value={iomData?.fromUser + " (" + iomData?.fromUserDesignation + ")"}
                                                        readOnly={true}
                                                    //onValueChanged={(e) => handleUserChange(e, "employeeId")}
                                                    />)
                                            }
                                        </div>
                                    </div>
                                </>
                            }

                            {iomApproversByWorkflow?.map((stage, index) => (
                                <div key={index} className="col-lg-4 col-md-12 col-sm-4 d-flex align-items-start">
                                    <div className="w-100">
                                        <label className="form-label">{stage?.actionTypeName}</label>
                                        {stage?.approvers?.map((approver, i) => (
                                            <input
                                                key={i}
                                                type="text"
                                                className="form-control"
                                                value={`${approver?.userName} (${approver?.designationName})`}
                                                readOnly
                                            />
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                ariaHideApp={false}
                isOpen={addVendorModalOpen}
                className="react-modal custom-modal-xlarge"
                //onRequestClose={closeModal}
                shouldCloseOnOverlayClick={false}
                contentLabel="Vendor Modal"
            >
                <div className="modal-header">
                    <h6 className="modal-title">{"Select Vendor"}</h6>
                </div>
                <div className="modal-body">
                    {/* Vendor SelectBox */}
                    <div className='row'>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="form-group mb-3">
                                <label>
                                    Vendor <span className="text-danger">*</span>
                                </label>
                                <SelectBox
                                    dataSource={vendorDropdownData}
                                    valueExpr="id"
                                    displayExpr="name"
                                    placeholder="Select vendor"
                                    searchEnabled
                                    showClearButton
                                    value={vendorData.vendorId}
                                    onValueChanged={(e) => {
                                        handleValueChange("vendorId", e.value);
                                        getVendorBankDetailsByVendorId(e.value);
                                    }}
                                />
                                {errors?.vendorId && (
                                    <div className="text-danger error invalid-feedback">{errors.vendorId}</div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Bank Selection Grid */}
                    <div className="bank-table mb-3">
                        <DataGrid
                            dataSource={vendorBankDetailList}
                            keyExpr="vendorBankId"
                            columnAutoWidth
                            showBorders
                            showRowLines
                            showColumnLines={false}
                            className="mb-3"
                        // onSelectionChanged={(e) => {
                        //     if (e.selectedRowKeys.length > 1) {
                        //         const latestKey = e.selectedRowKeys[e.selectedRowKeys.length - 1];
                        //         e.component.selectRows([latestKey], false); // keep only the last selected
                        //     }
                        //     handleValueChange("vendorBankData", e.selectedRowsData[0]);
                        // }}
                        >
                            {/* <Selection mode="multiple" showCheckBoxesMode="always" /> */}
                            <Column
                                width={50}
                                alignment='center'
                                caption=""
                                cellRender={({ data }) => {
                                    const isDuplicate = vendorDetailList?.some(
                                        item => item?.vendorId === data?.vendorId && item?.vendorBankId === data?.vendorBankId
                                    );
                                    return (
                                        <input
                                            type="radio"
                                            disabled={isDuplicate}
                                            name="vendorBankSelect"
                                            checked={selectedVendorId === data.vendorBankId}
                                            onChange={() => handleValueChange("vendorBankData", data)}
                                            style={{ cursor: "pointer" }}
                                        />
                                    )

                                }}
                            />
                            <Column dataField="bankName" caption="Bank" />
                            <Column dataField="branchName" caption="Branch" />
                            <Column dataField="accountHolderName" caption="Account Holder Name" />
                            <Column
                                dataField="accountNo"
                                caption="Account Number"
                                cellRender={({ value }) =>
                                    value?.replace(/\d(?=\d{4})/g, "x")
                                }
                            />
                            <Column dataField="accountType" caption="Account Type" />
                            <Column dataField="ifscCode" caption="IFSC Code" />
                        </DataGrid>
                        {errors?.bank && (
                            <div className="text-danger error invalid-feedback">{errors.bank}</div>
                        )}
                        {errors?.vendorBankId && (
                            <div className="text-danger error invalid-feedback">{errors.vendorBankId}</div>
                        )}
                    </div>
                    {/* Amount Inputs */}
                    <div className='row'>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="form-group">
                                <label>Ledger Balance</label>
                                <TextBox
                                    mode="number"
                                    placeholder='Enter amount'
                                    value={vendorData?.balanceAmount || 0}
                                    onValueChanged={(e) => {
                                        const value = Number(e.value);
                                        handleValueChange("balanceAmount", value < 0 ? 0 : value)
                                    }}
                                />
                                {/* {errors?.balanceAmount && (
                                    <div className="text-danger">{errors.balanceAmount}</div>
                                )} */}
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="form-group ">
                                <label>
                                    Recommended Amount <span className="text-danger">*</span>
                                </label>
                                <TextBox
                                    mode="number"
                                    placeholder='Enter amount'
                                    value={vendorData?.recommendedAmount}
                                    onValueChanged={(e) => {
                                        const value = Number(e.value);
                                        handleValueChange("recommendedAmount", value < 0 ? 0 : value)
                                    }}
                                />
                                {errors?.recommendedAmount && (
                                    <div className="text-danger error invalid-feedback">{errors.recommendedAmount}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className='row'>
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <div className="form-group mt-4">
                                        <CheckBox
                                            //defaultValue={0}
                                            text="Is Advance"
                                            value={vendorData?.isValidAdvance || false}
                                            onValueChanged={(e) => {
                                                handleValueChange("isValidAdvance", e.value)
                                            }}


                                        />
                                    </div>
                                </div>
                                {vendorData?.isValidAdvance && (
                                    <div className="col-lg-8 col-md-8 col-sm-12">
                                        <div className="form-group ">
                                            <label>
                                                Advance Request ID <span className="text-danger">*</span>
                                            </label>
                                            <TextBox
                                                mode="text"
                                                placeholder='Enter Advance request id'
                                                value={vendorData?.advRequestPaymentId}
                                                onValueChanged={(e) => {

                                                    handleValueChange("advRequestPaymentId", e?.value)
                                                }}
                                            />
                                            {errors?.advRequestPaymentId && (
                                                <div className="text-danger error invalid-feedback">{errors?.advRequestPaymentId}</div>
                                            )}
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>

                    </div>

                    {/* Note Input */}
                    <div className="form-group mb-3">
                        <label>
                            Note <span className="text-danger">*</span>
                        </label>
                        <TextArea
                            placeholder='Enter note'
                            value={vendorData.note}
                            onValueChanged={(e) => handleValueChange("note", e.value)}
                            height={70}
                        />
                        {errors?.note && <div className="text-danger error invalid-feedback">{errors.note}</div>}
                    </div>
                </div>

                {/* Footer Buttons */}
                <div className="modal-footer">
                    <Button
                        icon="close"
                        text="Cancel"
                        onClick={() => {
                            setAddVendorModalOpen(false);
                            setErrors({});
                            setVendorData({});
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2"
                    />
                    <Button
                        icon="check"
                        text="Submit"
                        type="success"
                        onClick={addVendorDetails}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </Modal>

            {/* Approval PopUp */}
            <Popup
                visible={isModalVisible}
                onHiding={() => setIsModalVisible(false)}
                showTitle={true}
                title="Approval"
                height="auto"
                weight="auto"
                className='custom-modal-popup'
            >
                <div className='popup-body'>
                    <div className='form-group'>
                        <label>Remark <span className="text-danger">*</span></label>
                        <TextArea
                            value={remarks}
                            onInput={(e) => handleAproveRemarksChange(e)}
                            height={90}
                            placeholder="Type your remarks..."
                            maxLength={300}
                        />
                        <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                            {charCount}/300 characters
                        </div>
                        {error.remarks && (
                            <div style={{ color: "red" }}>{error.remarks}</div>
                        )}
                    </div>

                </div>
                <div className='text-right'>

                    <Button
                        icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2" />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={handleApproveSubmit}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </Popup>
            {/* Save Popup */}
            <Popup
                visible={isSaveModalVisible}
                onHiding={() => setIsSaveModalVisible(false)}
                showTitle={true}
                title="Save"
                height="auto"
                weight="auto"
                className='custom-modal-popup'
            >
                <div className='popup-body'>
                    <div className='form-group'>
                        <label>Remark <span className="text-danger">*</span></label>
                        <TextArea
                            value={remarks}
                            onInput={(e) => handleAproveRemarksChange(e)}
                            height={90}
                            placeholder="Type your remarks..."
                            maxLength={300}
                        />
                        <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                            {charCount}/300 characters
                        </div>
                        {error.remarks && (
                            <div style={{ color: "red" }}>{error.remarks}</div>
                        )}
                    </div>

                </div>
                <div className='text-right'>

                    <Button
                        icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsSaveModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2" />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={() => {
                            addNewFundRequest(5);
                            setIsSaveModalVisible(false);
                        }}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </Popup>
            {loading && <Loader loadingMessage={""} />}
        </Fragment>
    )
}
